import React from 'react';

import { FallbackMessage } from './MissingTimeSlotsFallback.styled';
import { MemberServicesPhoneLink } from 'screens/Book/components/MemberServicesPhoneLink';

import { ContactPatientNavigatorLink } from '../ContactPatientNavigatorLink';

export const MissingTimeSlotsFallback = ({ phone }: { phone?: string }) => (
  <FallbackMessage>
    <h2>There are no available time slots for this appointment.</h2>
    <p>Please reach out for scheduling options.</p>
    <p>
      <ContactPatientNavigatorLink /> or call <MemberServicesPhoneLink phone={phone} />
    </p>
  </FallbackMessage>
);

export const DEFAULT_FALLBACK = <MissingTimeSlotsFallback />;
